/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQStudentOption } from './mCQStudentOption';
import type { MCQStudentQuestionSelectedOptionId } from './mCQStudentQuestionSelectedOptionId';
import type { MCQStudentQuestionDifficulty } from './mCQStudentQuestionDifficulty';
import type { MCQStudentQuestionImageUrl } from './mCQStudentQuestionImageUrl';
import type { MCQStudentQuestionImageAlt } from './mCQStudentQuestionImageAlt';

/**
 * MCQ question as shown to students (shuffled, no correct answers).
 */
export interface MCQStudentQuestion {
  id: string;
  text: string;
  options: MCQStudentOption[];
  selectedOptionId?: MCQStudentQuestionSelectedOptionId;
  difficulty?: MCQStudentQuestionDifficulty;
  imageUrl?: MCQStudentQuestionImageUrl;
  imageAlt?: MCQStudentQuestionImageAlt;
}
